import React from "react";
import Button from "@amzn/meridian/button";
import "./ThemedButton.scss";

interface ThemedButtonProps {
    children: React.ReactNode;
    onClick: () => void;
    disabled?: boolean;
}

const ThemedButton: React.FC<ThemedButtonProps> = ({ children, onClick, disabled = false }) => {
    return (
        <div className="themed-button__wrapper">
            <Button minWidth="100%" className="themed-button" type="primary" size="large" onClick={onClick} disabled={disabled}>
                {children}
            </Button>
        </div>
    );
};

export default ThemedButton;
